import { render, staticRenderFns } from "./mobile_consult_detail.vue?vue&type=template&id=df22a5c4&scoped=true&"
import script from "./mobile_consult_detail.vue?vue&type=script&lang=js&"
export * from "./mobile_consult_detail.vue?vue&type=script&lang=js&"
import style0 from "./mobile_consult_detail.vue?vue&type=style&index=0&id=df22a5c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df22a5c4",
  null
  
)

export default component.exports